import { useLanguage } from '../../../contexts/LanguageContext';

export default function Footer() {
  const { t } = useLanguage();

  return (
    <footer className="bg-[#1a4d2e] pt-16 pb-8 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="border-t border-[#f5f1e8]/20 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-[#f5f1e8]/60 text-sm font-serif">
              {t('footer.copyright')}
            </p>
            <div className="flex items-center gap-6">
              <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-[#f5f1e8]/60 hover:text-[#ff6b4a] text-sm transition-colors cursor-pointer">
                Powered by Readdy
              </a>
              <a href="#" className="text-[#f5f1e8]/60 hover:text-[#ff6b4a] text-sm transition-colors cursor-pointer">{t('footer.privacy')}</a>
              <a href="#" className="text-[#f5f1e8]/60 hover:text-[#ff6b4a] text-sm transition-colors cursor-pointer">{t('footer.terms')}</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
